module.exports = __webpack_public_path__ + "static/media/Genesis-Desktop-Banner-@2-2440x300.86ff8145.jpg";